import { Component } from '@angular/core';

@Component({
  selector: 'container',
  templateUrl: './container.component.html',
})
export class ContainerComponent {

}
